import React, { useState } from "react";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

import PricingCard, { PricingDetails } from "../PricingCard";

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
  },
  "& .MuiSwitch-thumb": { width: 16, height: 16 },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#04092152",
  },
}));

const HomePricing = () => {
  const [isYearly, setIsYearly] = useState(false);
  const [selectedIdx, setSelectedIdx] = useState(1);
  const navigate = useNavigate();

  const handleToggle = () => setIsYearly((prev) => !prev);

  const handleGetStarted = (index) => {
    const plan = PricingDetails[index];
    navigate("/create-organization", {
      state: {
        selectedPlan: plan.name,
        planCode: plan.code,
        isYearly,
      },
    });
  };

  return (
    <div id="pricing" className="bg-[#FAF8F7] h-full py-16 px-4 md:px-12">
      <div className="flex flex-col items-center text-center mb-8">
        <h2 className="text-4xl font-bold">
          Powerful features for <br />
          <span
            className="bg-clip-text text-transparent"
            style={{
              backgroundImage: "linear-gradient(90deg,#1D4ED8,#55CBFB)",
            }}
          >
            powerful creators
          </span>
        </h2>

        <p className="my-3 text-lg font-[400]">
          Choose a plan that’s right for you
        </p>

        <div className="mt-6 flex items-center gap-4">
          <p>Pay Monthly</p>
          <IOSSwitch onChange={handleToggle} checked={isYearly} />
          <p>Pay Yearly</p>
        </div>
      </div>

      {/* Pricing Cards */}
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PricingDetails.map((plan, idx) => (
            <PricingCard
              key={idx}
              plan={plan}
              isSelected={selectedIdx === idx}
              isYearly={isYearly}
              onSelect={() => setSelectedIdx(idx)}
              onContinue={() => handleGetStarted(idx)}
              buttonText="Get Started Now"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomePricing;
